import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { NAV, NAV_MINIFIED, USER_AUTH_LOGOUT } from '../../constants/action-types';

// const SideBarItem = ({ value, text, icon, onClick, isSelected }) => {
//     return (
//         <li className={"nav-item" + (isSelected(value) ? " active-item" : "")}>
//             <a className="nav-link" href="#" onClick={() => onClick(value)}>
//                 <div className="navItemText">{text}</div>
//             </a>
//         </li>
//     )
// };

class Sidebar extends Component {
    constructor(props) {
        super(props);
    }

    getClassList() {

        let classList = ''

        if (window.outerWidth > 768)
        
            classList += 'show '

        else {
            
            classList += this.props.nav.showNav ? 'show' : 'hide'

        }

        return classList

    }

    render() {

        // Get the hash as an array.
        const balances = Object.keys(this.props.user.balances).map(key => new Object({[key]: this.props.user.balances[key]}))
        
        return (
            <nav className={this.getClassList()}> 
                <div id='nav-top'>
                    <div id='nav-head'>
                        <img className='logo logo-non-minified' src='/img/logo.png' alt=''/>
                        <img className='logo logo-minified' src='/img/logoV.png' alt=''/>
                        <small className='nav-head-motto'>Betting redefined</small>
                    
                    </div>
                    {/* {this.props.user.balancesError ? (
                        (<div id='mevu-balances-error'>Could not get balances with error: {this.props.user.balancesError}</div>)
                    ) : null}
                    <ul id='mevu-balances'>
                        {balances.map(bal => (
                            <li>{bal}</li>
                        ))}
                    </ul> */}
                    <ul id='nav-top-list'>
                        <li onClick={this.props.navTo.bind(this, '/events')}>
                            <a>
                                <span className='icon icon-calendar-2'></span>
                                <h6 className='mvu-title'>Events</h6>
                            </a>
                        </li> 
                        <li onClick={this.props.navTo.bind(this, '/bets')}>
                            <a>
                                <span className='icon icon-user'></span>
                                <h6 className='mvu-title'>Bets</h6>
                            </a>
                        </li>
                        <li onClick={this.props.navTo.bind(this, '/oracle')}>
                            <a>
                                <span className='icon icon-database'></span>
                                <h6 className='mvu-title'>Oracles</h6>
                            </a>
                        </li>
                        <li onClick={this.props.navTo.bind(this, '/leaderboard')}>
                            <a>
                                <span className='icon icon-trophy'></span>
                                <h6 className='mvu-title'>Leaderboard</h6>
                            </a>
                        </li>
                    </ul>
                </div>
                    {this.props.user.user ? (
                        <ul id='nav-bottom'>
                            <li className='hideMinified'>
                                <small>Logged in as {this.props.user.user.email}</small>
                            </li>
                            <li onClick={this.props.logout.bind(this)}>
                                <a>
                                    <span className='icon icon-log-out'></span>
                                    <h6 className='mvu-title'>Log out</h6>
                                </a>
                            </li>
                        </ul>
                    ) : (null)}
            </nav>
        );
    }
}


const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({

    logout: () => dispatch({type: USER_AUTH_LOGOUT}),
    navTo: (pathname) => dispatch({ type: NAV, pathname })

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Sidebar)


// WEBPACK FOOTER //
// ./src/components/general/Sidebar.js